
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {dataFieldsEditModule} from "@/store";
import DataFieldCache from "../../../models/data.field.cache";
import DataFieldBar from "@/components/study/datafields/base/DataFieldBar.vue";
import {translate} from "@/auxillary/translation";
import {stringify} from '@/auxillary/datafield.stringify';
import Hints from "@/components/study/datafields/base/Hints.vue";

import {findEnumValueSet, activeEnumValues} from "@/auxillary/enum.lookup";

@Component({
  name: 'EnumerationField',
  components: {
    Hints,
    DataFieldBar,
    OkDialog
  },
})
export default class EnumerationField extends Vue {

  @Prop({required: true})
  private dataField: DataFieldCache

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return !this.field.isEditable;
  }

  get field() {
    return this.dataField;
  }

  get value() {
    return this.dataField?.values?.value
  }

  get enumValues() {
    const enumValues = Array.from(activeEnumValues(this.enumValueSet))
        .map(e => ({code: e.code, displayName: translate(e.displayKey)}));
    if (this.canBeUnknown || this.value == "unknown")
      if (enumValues.find(e => e.code == "unknown") == undefined)
        enumValues.push({code: "unknown", displayName: this.isRow ? "unbekannt" : "Unbekannt"});
    return enumValues
  }

  set value(value: string) {
    dataFieldsEditModule.setValue({field: this.dataField, key: "value", value})
  }

  stringifyValue() {
    return stringify(this.field)
  }

  get isSelect() {
    return this.dataField.definition.ui?.control === "select" || (activeEnumValues(this.enumValueSet).length > 9)
  }

  get isRow() {
    return (this.dataField.definition.ui?.displayDirection !== "vertical" && (activeEnumValues(this.enumValueSet).length <= 3)) || this.dataField.definition.ui?.displayDirection == "horizontal"
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get displayName() {
    if (!this.dataField.displayName)
      return ""
    return this.dataField.displayName + (this.isRequired ? "<span style='color:red;'>*</span>" : "");
  }

  get isRequired() {
    return this.dataField.isRequired
  }

  get enumValueSet() {
    return findEnumValueSet(this.dataField.definition.enum);
  }

  translate(displayKey: string) {
    return translate(displayKey)
  }
}
